if (!customElements.get('combo-progress')) {
  class ComboProgress extends HTMLElement {
    connectedCallback() {
      const total    = parseInt(this.dataset.total, 10);
      const shipping = parseInt(this.dataset.shipping, 10) || 0;
      const gift     = parseInt(this.dataset.gift, 10) || 0; // 0 = gift disabled
      const fmt      = (window.theme && window.theme.settings.money_with_currency_format) || 'kr. {{amount}}';

      const textEl           = this.querySelector('.combo-progress__text');
      const checkpointEl     = this.querySelector('.combo-progress__checkpoint:not(.combo-progress__checkpoint--gift)');
      const giftCheckpointEl = this.querySelector('.combo-progress__checkpoint--gift');

      // Bar maxes out at the furthest active threshold (gift is always >= shipping)
      const max = gift > 0 ? gift : shipping;
      if (!max) {
        this.hidden = true;
        return;
      }

      // Position shipping checkpoint marker
      if (checkpointEl && shipping > 0) {
        checkpointEl.style.left = ((shipping / max) * 100) + '%';
        if (total >= shipping) checkpointEl.classList.add('is-unlocked');
      }

      // Unlock gift checkpoint
      if (giftCheckpointEl && gift > 0 && total >= gift) {
        giftCheckpointEl.classList.add('is-unlocked');
      }

      // Fill bar
      this.style.setProperty('--progress', Math.min(total / max, 1));

      // Message — copy comes from locale-driven data attributes (see combo-progress.liquid).
      const S = this.dataset;
      const amount = (v) => '<strong>' + formatMoney(v, fmt) + '</strong>';
      let msg;
      if (shipping > 0 && total < shipping) {
        msg = (S.strRemainingShipping || '[amount]').replace('[amount]', amount(shipping - total));
      } else if (gift > 0 && total < gift) {
        const prefix = shipping > 0 ? (S.strShippingPrefix || '') : '';
        msg = prefix + (S.strRemainingGift || '[amount]').replace('[amount]', amount(gift - total));
      } else if (gift > 0) {
        msg = shipping > 0 ? (S.strBothUnlocked || '') : (S.strGiftUnlocked || '');
      } else {
        msg = S.strShippingUnlocked || '';
      }
      textEl.innerHTML = msg;
    }
  }
  customElements.define('combo-progress', ComboProgress);
}
